import { render, staticRenderFns } from "./AdminTPDPopups.vue?vue&type=template&id=5f6b7444"
import script from "./AdminTPDPopups.vue?vue&type=script&lang=js"
export * from "./AdminTPDPopups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports